import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { ShoppingCart } from "lucide-react";

const ProductList = ({ products }) => {
  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();
  const [sparkles, setSparkles] = useState({});

  const handleCardClick = (id) => {
    navigate(`/product/${id}`);
  };

  const handleAddToCart = (e, product) => {
    e.stopPropagation();
    addToCart(product);
    setSparkles((prev) => ({ ...prev, [product._id]: true }));
    setTimeout(() => {
      setSparkles((prev) => ({ ...prev, [product._id]: false }));
    }, 1000);
  };

  return (
    <div className="relative">
      <style>
        {`
          @keyframes sparkleJump {
            0% {
              transform: translateY(0) scale(1);
              opacity: 1;
            }
            30% {
              transform: translateY(-5px) scale(1.1);
            }
            50% {
              transform: translateY(-10px) scale(1.1) rotate(5deg);
            }
            70% {
              transform: translateY(-15px) scale(1) rotate(-5deg);
            }
            100% {
              transform: translateY(-20px) scale(0.8);
              opacity: 0;
            }
          }
        `}
      </style>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {products.map((product) => {
          const finalPrice =
            product.discount > 0
              ? (product.price * (1 - product.discount / 100)).toFixed(2)
              : product.price.toFixed(2);

          return (
            <div
              key={product._id}
              style={{ height: "380px" }}
              className="relative bg-white border rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-transform transform hover:scale-105 overflow-visible p-4"
              onClick={() => handleCardClick(product._id)}
            >
              {product.discount > 0 && (
                <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded">
                  -{product.discount}%
                </span>
              )}
              {product.stock <= 0 && (
                <span className="absolute top-2 right-2 bg-gray-400 text-white text-xs font-bold px-2 py-0.5 rounded">
                  Sin stock
                </span>
              )}

              {/* Ajustamos la ruta y usamos object-contain para evitar recorte */}
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}/uploads/ProductImage/${product.image}`}
                alt={product.title}
                className="w-full h-48 object-contain rounded mb-2"
              />

              <button
                onClick={(e) => handleAddToCart(e, product)}
                disabled={product.stock <= 0}
                className={`absolute bottom-4 right-4 w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                  product.stock > 0
                    ? "bg-blue-500 text-white hover:bg-blue-600"
                    : "bg-gray-400 text-white cursor-not-allowed"
                }`}
              >
                <ShoppingCart size={18} />
              </button>

              <div className="absolute bottom-4 left-4 right-16 text-left">
                <h2 className="font-bold text-lg">{product.title}</h2>
                {product.discount > 0 ? (
                  <p className="text-gray-600">
                    <span className="line-through text-red-500">${product.price}</span>{" "}
                    <span className="font-bold">${finalPrice}</span>
                  </p>
                ) : (
                  <p className="text-gray-600">${finalPrice}</p>
                )}
                {product.stock > 0 && (
                  <p className="text-sm text-gray-500 mt-1">Stock: {product.stock}</p>
                )}
              </div>

              {sparkles[product._id] && (
                <div
                  className="absolute"
                  style={{
                    bottom: "4rem",
                    right: "3.5rem",
                    width: "1px",
                    height: "1px",
                    zIndex: 9999,
                  }}
                >
                  <span
                    className="text-yellow-400 text-xl"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "-1rem",
                      animation: "sparkleJump 0.8s forwards",
                      animationDelay: "0s",
                    }}
                  >
                    ⭐
                  </span>
                  <span
                    className="text-yellow-300 text-xl"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      animation: "sparkleJump 0.8s forwards",
                      animationDelay: "0.1s",
                    }}
                  >
                    ✨
                  </span>
                  <span
                    className="text-yellow-500 text-xl"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "1rem",
                      animation: "sparkleJump 0.8s forwards",
                      animationDelay: "0.2s",
                    }}
                  >
                    🌟
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductList;
